
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole" [ngClass]="{'general-disabled': deployment?.isMigrationActive}">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Select assets to add to the deployment:</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <asset-picker [pageSize]="5" (onAssetSelected)="assetSelected($event)" (onChange)="setDirty()" [deploymentId]="deploymentId" [disableInstalled]="true" [includeRemovals]="true"></asset-picker>
</div>